/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Language Manager Module - Управление языками интерфейса
 */

(function(window) {
    'use strict';

    const LanguageManager = {};

    // Поддерживаемые языки
    const SUPPORTED_LANGUAGES = ['RU', 'EN', 'DE', 'ES', 'FR'];
    
    // Текущий язык
    let currentLang = window.LANG_BROWSER || 'EN';

    /**
     * Инициализирует менеджер языков
     */
    LanguageManager.init = function() {
        // Создаем стеммеры для поддерживаемых языков
        if (window.snowballFactory) {
            LanguageManager.stem = {};
            LanguageManager.stem['RU'] = snowballFactory.newStemmer('russian');
            LanguageManager.stem['EN'] = snowballFactory.newStemmer('english');
            // Добавьте другие языки по необходимости
        }

        // Проверяем и устанавливаем язык
        currentLang = LanguageManager.checkAndSetLanguage();
        window.LANG = currentLang;

        // Инициализируем ссылки переключения языка
        LanguageManager.initLanguageLinks();

        // Language Manager initialization logging only in debug mode
        if (false && window.HyperLog) {
            HyperLog.debug("Language Manager initialized", { 
                currentLang: currentLang,
                supportedLanguages: SUPPORTED_LANGUAGES,
                stemmersLoaded: LanguageManager.stem ? Object.keys(LanguageManager.stem) : []
            });
        }

        return currentLang;
    };

    /**
     * Проверяет и устанавливает язык из cookies/браузера
     */
    LanguageManager.checkAndSetLanguage = function(forceLang = '') {
        let lang = 'EN';
        
        // Если язык уже задан с сервера, используем его
        if (typeof window.LANG_FROM_SERVER !== 'undefined' && window.LANG_FROM_SERVER) {
            lang = window.LANG_FROM_SERVER.toUpperCase();
        } else if (forceLang !== '') {
            // Если язык задан явно, используем его
            lang = forceLang.toUpperCase();
        } else {
            // Определяем язык из cookies или браузера
            // 1. Проверяем cookie
            if (typeof window.$ !== 'undefined' && window.$.cookie) {
                const cookieLang = window.$.cookie('preferred_language');
                if (cookieLang && SUPPORTED_LANGUAGES.includes(cookieLang.toUpperCase())) {
                    lang = cookieLang.toUpperCase();
                }
            }
            
            // 2. Если нет в cookie, проверяем браузер
            if (lang === 'EN' && !(typeof window.$ !== 'undefined' && window.$.cookie && window.$.cookie('preferred_language'))) {
                const browserLang = (navigator.language || navigator.userLanguage || '').split('-')[0].toUpperCase();
                if (SUPPORTED_LANGUAGES.includes(browserLang)) {
                    lang = browserLang;
                    // Сохраняем в cookie
                    if (typeof window.$ !== 'undefined' && window.$.cookie) {
                        window.$.cookie('preferred_language', lang, { expires: 365, path: '/' });
                    }
                }
            }
        }

        // Проверяем, что язык поддерживается
        if (!SUPPORTED_LANGUAGES.includes(lang)) {
            lang = 'EN'; // Fallback to English
        }

        currentLang = lang;
        return lang;
    };

    /**
     * Возвращает текущий URL без изменения (язык хранится в cookie, не в URL)
     */
    LanguageManager.getLanguageUrl = function(newLang) {
        // Язык больше не хранится в URL, возвращаем текущий URL без изменений
        return window.location.href;
    };

    /**
     * Меняет язык, сохраняя его в cookie и перезагружая страницу
     * URL не изменяется (язык хранится в cookie)
     */
    LanguageManager.switchLanguagePrefix = function(newLang) {
        const newLangUpper = (newLang || currentLang).toUpperCase();
        
        // Проверяем, что язык поддерживается
        if (!SUPPORTED_LANGUAGES.includes(newLangUpper)) {
            return false;
        }
        
        // Сохраняем язык в cookie
        if (typeof window.$ !== 'undefined' && window.$.cookie) {
            window.$.cookie('preferred_language', newLangUpper, { expires: 365, path: '/' });
        }
        
        // Обновляем текущий язык
        currentLang = newLangUpper;
        window.LANG = newLangUpper;
        
        // Перезагружаем страницу для применения языка (без изменения URL)
        window.location.reload();
        
        return true;
    };

    /**
     * Инициализирует ссылки переключения языка на странице
     * Устанавливает обработчики кликов для переключения языка через cookie (без изменения URL)
     */
    LanguageManager.initLanguageLinks = function() {
        // Idempotent: per-element guard `dataset.langHandlerBound` prevents
        // duplicate click listeners when this function is invoked multiple
        // times. Earlier impl iterated `.language-switch` AND
        // `.language-menu a[data-lang]` — selectors that OVERLAP (each
        // dropdown item carries BOTH classes), so each link got TWO
        // handlers per call. The function is also invoked twice in normal
        // boot (`DOMContentLoaded` gate below + `language_dropdown_init.html`
        // after Bootstrap dropdown init), so each link ended up with 4+
        // handlers. One language-switch click then fired N synchronous
        // `window.location.reload()` calls in a row; each subsequent reload
        // cancelled the previous navigation, producing a stream of
        // cancelled `search/` requests in DevTools (all sourced at
        // `language-manager.js:125`). User-reported regression 2026-05-05.
        const bind = function (link) {
            const lang = link.getAttribute && link.getAttribute('data-lang');
            if (!lang) return;
            if (link.dataset && link.dataset.langHandlerBound === '1') return;
            link.setAttribute('href', '#');
            link.addEventListener('click', function (e) {
                e.preventDefault();
                LanguageManager.switchLanguagePrefix(lang);
            });
            if (link.dataset) link.dataset.langHandlerBound = '1';
        };
        // Union of both selector groups deduped via Set — covers
        // `.language-switch` items AND any future `[data-lang]` anchor
        // inside `.language-menu` without double-binding overlapping nodes.
        const union = new Set();
        document.querySelectorAll('.language-switch').forEach(el => union.add(el));
        document.querySelectorAll('.language-menu a[data-lang]').forEach(el => union.add(el));
        union.forEach(bind);
    };

    // Инициализация ссылок при загрузке DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            if (window.LanguageManager && typeof window.LanguageManager.initLanguageLinks === 'function') {
                window.LanguageManager.initLanguageLinks();
            }
        });
    } else {
        // DOM уже загружен
        if (window.LanguageManager && typeof window.LanguageManager.initLanguageLinks === 'function') {
            window.LanguageManager.initLanguageLinks();
        }
    }

    /**
     * Устанавливает язык и перезагружает страницу (язык сохраняется в cookie)
     */
    LanguageManager.redirectToLanguage = function(lang) {
        LanguageManager.switchLanguagePrefix(lang);
    };

    /**
     * Получает текущий язык
     */
    LanguageManager.getCurrentLanguage = function() {
        return currentLang;
    };

    /**
     * Переводит текст на текущий язык
     * Uses TranslationRegistry if available, falls back to legacy method
     */
    LanguageManager.translate = function(key, category = null) {
        // Use TranslationRegistry if available (new system)
        if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
            try {
                const translation = window.TranslationRegistry.translate(key, currentLang);
                // If TranslationRegistry returned the key unchanged, it means translation not found
                // Fall through to legacy method for backward compatibility
                if (translation !== key) {
                    return translation;
                }
            } catch (e) {
                console.debug('[LanguageManager] TranslationRegistry error, falling back to legacy:', e);
            }
        }
        
        return key; // Return key if translation not found
    };

    /**
     * Получает стеммер для текущего языка
     */
    LanguageManager.getStemmer = function(lang = null) {
        const targetLang = lang || currentLang;
        return LanguageManager.stem && LanguageManager.stem[targetLang] ? 
               LanguageManager.stem[targetLang] : null;
    };

    /**
     * Определяет язык материала по пути
     */
    LanguageManager.detectMaterialLanguage = function(path) {
        const languagePattern = /(\ben(?=glish)|ru(?=ssian)|ge(?=rman)|sp(?=anish)|fr(?=anz)|ja(?=pan))/i;
        const match = path.match(languagePattern);
        
        if (match) {
            let detectedLang = match[1].toUpperCase();
            // Преобразуем сокращения в стандартные коды
            const langMap = {
                        'SP': 'ES',
        'JA': 'JP',
        'GE': 'DE'
            };
            
            return langMap[detectedLang] || detectedLang;
        }
        
        return '';
    };

    /**
     * Получает название языка для отображения
     */
    LanguageManager.getLanguageTitle = function(langCode) {
        const titles = {
                    'RU': 'Русский',
        'EN': 'English',
        'DE': 'Deutsch',
        'ES': 'Español',
        'FR': 'Français',
        'JP': '日本語'
        };
        
        return titles[langCode] || langCode;
    };

    /**
     * Сортирует языки, помещая текущий язык первым
     */
    LanguageManager.sortLanguages = function(languages) {
        return languages.reduce((acc, element) => {
            if (element === currentLang) {
                return [element, ...acc];
            }
            return [...acc, element];
        }, []);
    };

    /**
     * Устанавливает язык и сохраняет в cookie
     */
    LanguageManager.setLanguage = function(lang) {
        const langUpper = (lang || currentLang).toUpperCase();
        
        // Проверяем, что язык поддерживается
        if (!SUPPORTED_LANGUAGES.includes(langUpper)) {
            return false;
        }
        
        // Сохраняем в cookie
        if (typeof window.$ !== 'undefined' && window.$.cookie) {
            window.$.cookie('preferred_language', langUpper, { expires: 365, path: '/' });
        }
        
        // Устанавливаем язык
        const result = LanguageManager.checkAndSetLanguage(lang);
        return result;
    };

    /**
     * Получает язык (алиас для getCurrentLanguage для современного API)
     */
    LanguageManager.getLanguage = function() {
        return LanguageManager.getCurrentLanguage();
    };

    // Экспорт модуля
    window.LanguageManager = LanguageManager;

    // Для обратной совместимости
    window.langCheckReload = function(lang = '') {
        const newLang = LanguageManager.checkAndSetLanguage(lang);
        // Если язык задан явно, переключаем его
        if (lang !== '') {
            LanguageManager.switchLanguagePrefix(newLang);
        }
        return newLang;
    };

    // Глобальная функция для переключения языка (используется в language_selector.js)
    // Сохраняет язык в cookie и перезагружает страницу без изменения URL
    window.changeLanguage = function(newLang) {
        if (window.LanguageManager && typeof window.LanguageManager.switchLanguagePrefix === 'function') {
            return window.LanguageManager.switchLanguagePrefix(newLang);
        }
        // Fallback: сохраняем в cookie и перезагружаем
        if (typeof window.$ !== 'undefined' && window.$.cookie) {
            window.$.cookie('preferred_language', newLang.toUpperCase(), { expires: 365, path: '/' });
        }
        window.location.reload();
        return true;
    };

    // ES Module export for modern imports
    if (typeof window !== 'undefined') {
        window.languageManager = LanguageManager;
    }

    // Инициализация ссылок при загрузке DOM (после экспорта)
    (function initLanguageLinksOnReady() {
        function doInit() {
            if (window.LanguageManager && typeof window.LanguageManager.initLanguageLinks === 'function') {
                window.LanguageManager.initLanguageLinks();
            }
        }
        
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', doInit);
        } else {
            // DOM уже загружен
            setTimeout(doInit, 0);
        }
    })();

})(window); 

// ES Module export
export const languageManager = window.LanguageManager || {}; 